






























































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import user from '@/store/modules/user';
import redirectToLocation from '@/commons/redirectManager';
import cart from '@/store/modules/cart';
import {availablesSocial, socialPopup} from '@/commons/socialHandler';
import handleMessage from '@/commons/messageManager';
import device from '@/store/modules/device';
import CmsBlock from '@/components/Cms/Block.vue';
import store from '@/store';
import getRecaptchaToken from '@/commons/recaptcha';
import ShowPassword from './ShowPassword.vue';
import Recaptcha from '../Recaptcha.vue';
import app from '@/store/modules/app';
import {isEmpty, lowerCase} from 'lodash';

@Component({
    components: {
        ShowPassword,
        CmsBlock,
        Recaptcha,
    },
})
export default class Login extends Vue {
    @Prop() public showRegistrationButton!: boolean;
    @Prop() public showLoginStepTitle!: boolean;
    public showPassword: boolean = false;
    private email: string = '';
    private password: string = '';
    private loading = false;

    get isApp() {
        return device.isApp;
    }

    get isIos(){
        return device.isIos;
    }
    get socials() {
        return availablesSocial.socials;
    }

    get socialsEnabled() {
        return !isEmpty(this.socials);
    }


    get showLoginRecaptcha() {
        return store.state.options.recaptcha.show_in_customer_login_form;
    }

    private async login(email: string, password: string) {
        const valid = await this.$validator.validateAll();
        let loginToken = '';

        if (!valid) {
            this.$validator.errors.all().forEach((error) => {
                handleMessage('error', error);
            });

            return;
        }

        if (this.showLoginRecaptcha) {
            loginToken = await getRecaptchaToken('login');

            if (!loginToken) {
                return;
            }
        }

        this.loading = true;

        const promise: Promise<string> = user.login({
            username: email,
            password,
            cartToken: cart.token,
            recaptchaToken: loginToken,
        });

        promise
            .then(() => {
                // il guard della route si occupa di smistare sullo step corretto
                redirectToLocation('checkout/shipping', true);
            })
            .catch(() => {
                this.loading = false;
            });
    }

    private showForgotPasswordForm() {
        this.$emit('showForgotPasswordForm');
    }

    private showRegistrationForm() {
        this.$emit('showRegistrationForm');
    }

    private openSocialPopup(social: string, urlSocial: string) {
        if (app.isApp) {
            app.socialLogin(social);
        } else {
            socialPopup(urlSocial);
        }
    }

    private isEnabledIosSocial(social: string) {
        const config = 'app_ios_' + social.toLowerCase();
        return store.state.options.socialAvailables[config]
    }

    private isEnabledAndroidSocial(social: string) {
        const config = 'app_android_' + social.toLowerCase();
        return store.state.options.socialAvailables[config]
    }

    private isEnabledDeviceIosSocial(social: string) {
        const config = 'device_ios_' + social.toLowerCase();
        return store.state.options.socialAvailables[config]
    }
}
